import angular from 'angular';
import reportForm from './report-form.component';
import './report-form.scss';

export default angular.module('components.app.reports.reportForm', [])
  .component('reportForm', reportForm)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/reports/report-form/report-form.module.js